const noSpecialCharacters = (value) => {
  if (!value) return true
  return !!value.match(/^[\sa-zA-Z0-9#\&*\)\(.-]+$/)
}

const noNumbers = (value) => {
  if (!value) return true
    return !!value.match(/^([^0-9]*)$/)
}

export {
  noSpecialCharacters,
  noNumbers
}
